import React from 'react';
import { Box, FormHelperText } from '@mui/material';
import { StyledDatePicker } from './StyledComponents';

const CustomDatePicker = ({ value, onChange, error, helperText }) => (
  <Box sx={{ position: 'relative' }}>
    <StyledDatePicker
      selected={value}
      onChange={onChange}
      dateFormat="MM/dd/yyyy"
      placeholderText="Report Date"
      error={error}
      className={error ? "error" : ""}
      popperClassName="datepicker-popper"
      popperPlacement="bottom-start"
      popperModifiers={[
        {
          name: "preventOverflow",
          options: {
            enabled: true,
            escapeWithReference: false,
            boundary: "viewport"
          }
        }
      ]}
      style={{
        height: "56px",
        fontSize: "1rem",
        fontFamily: "inherit",
        padding: "0 14px",
        width: "100%",
        border: `1px solid ${error ? "#d32f2f" : "#eeeeee"}`,
        borderRadius: "4px",
        boxSizing: "border-box",
      }}
    />
    {error && (
      <FormHelperText error sx={{ mt: 1 }}>
        {helperText}
      </FormHelperText>
    )}
    <style>
      {`
        .datepicker-popper {
          z-index: 9999 !important;
        }
        .react-datepicker-popper {
          z-index: 9999 !important;
        }
        .react-datepicker-wrapper {
          width: 100%;
        }
      `}
    </style>
  </Box>
);

export default CustomDatePicker; 